module.exports = __webpack_public_path__ + "img/73.203f6c37.jpg";